import { Avatar } from "@mui/material";

interface Props {
  number: number;
  size: number;
}

const NumberAvatar = ({ number, size }: Props) => (
  <Avatar variant="rounded" sx={{ height: size, width: size, fontSize: 11, fontWeight: 500 }}>
    {number}
  </Avatar>
);

export default NumberAvatar;
